'use strict';

angular.module('financeApplicationController', [])

.controller('FinanceApplicationController', ['appInfo', '$routeParams', '$scope', '$rootScope', '$log', '$location', '$window','PropertyService', 'BuyerService', 'CommonService',
    function (appInfo, $routeParams, $scope, $rootScope, $log, $location, $window, PropertyService, BuyerService, CommonService) {    
   
    $scope.page = 'financeApplication';
    $scope.property = {};
    $scope.showDisclamer = false;
    var currentUser = $rootScope.currentUser;



    $scope.requestTypes = [ 
        { name: 'First home buyer' }, 
        { name: 'Pre approval' }, 
        { name: 'Refinancing' }, 
        { name: 'Investment' } 
    ];

    $scope.financeApplicationRequest = {
        requestTypes: [],
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        postcode: '',
        suburb: '',
        disclamer: false
    };

    var init = function() {

        if($routeParams.propertyRef) {
            $rootScope.loading = true;
            PropertyService.getProperty($routeParams.propertyRef)
            .then(function(data){
                $scope.property = data[0];
            })
            .catch(function(err){
                console.log(err);
            })
            .finally(function(data){
                $rootScope.loading = false;
            });

        }

        $scope.financeApplicationRequest = {
            requestTypes: [],
            firstName: currentUser.nameFirst,
            lastName: currentUser.nameLast,
            email: currentUser.info.email,
            phone: currentUser.info.mobile,
            postcode: '',
            suburb: '',
            disclamer: false
        };

        if(currentUser.addressDetails.length > 0) {
            $scope.financeApplicationRequest.postcode = currentUser.addressDetails[0].postcode;
            $scope.financeApplicationRequest.suburb = currentUser.addressDetails[0].locationName;
        }
       
    }

    $scope.submitFinanceApplication = function() {
        var errMsg = '';
        $scope.financeApplicationRequest.requestTypes = [];
        angular.forEach($scope.requestTypes, function(requestType){
            if(requestType.selected) {
                $scope.financeApplicationRequest.requestTypes.push(requestType.name);
            }
        });
        if($scope.financeApplicationRequest.requestTypes.length <= 0) {
            errMsg += 'Please select what best describes your request.\n';
        }
        if($scope.financeApplicationRequest.firstName.trim() == '') {
            errMsg += 'Please enter your first name.\n';
        }
        if(!$scope.financeApplicationRequest.disclamer) {
            errMsg += 'Please read the disclamer and select that you have read disclamer.\n';
        }
        if(errMsg !='') {
            alert(errMsg);
        } else {
            $rootScope.loading = true;
            BuyerService.sendFinanceApplicationEmail($scope.financeApplicationRequest, $scope.property)
            .then(function(data) {
                alert('Your finance application request has been sent to agent.');
            })
            .catch(function(err){
                console.log(err);
            })
            .finally(function(data){
                $rootScope.loading = false;
            });
        }
         
    }

    $scope.showDisclamerContent = function() {
        $scope.showDisclamer = true;
    }

    $scope.back = function() {
        if($routeParams.previousPage) {
            $location.path($routeParams.previousPage).search({});
        }
    }
  
    init();

}]);